import { motion } from "framer-motion";
import { ScrollReveal } from "./MaskedReveal";

const FACTS = [
  "Документални филми и брандирани кампании",
  "Основател на ZAGRAZHDENFILMFEST",
  "Магистър Артмениджмънт — АМТИИ Пловдив",
  "Бакалавър Медия и комуникации — Glasgow Caledonian University",
  "5+ години опит",
];

export const Credits = () => (
  <section id="zad-kadar" className="border-t border-[#14110D]/10 py-24" data-testid="credits-block">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
      <ScrollReveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C8402A]">§ Зад кадър</p>
        <h2 className="mt-2 font-serif text-4xl uppercase tracking-tight text-[#14110D] sm:text-5xl">
          За мен
        </h2>
      </ScrollReveal>

      <div className="mt-12 grid items-center gap-12 lg:grid-cols-[0.85fr_1.15fr]">
        <ScrollReveal delay={0.1}>
          <motion.figure
            data-testid="about-photo"
            className="relative overflow-hidden rounded-[2rem] border border-[#14110D]/15"
            whileHover={{ scale: 0.99 }}
            transition={{ duration: 0.4 }}
          >
            <img
              src="/aleksandar.webp"
              alt="Александър Чолаков зад камерата"
              className="aspect-[4/5] w-full object-cover"
            />
            <figcaption className="absolute bottom-4 left-4 rounded-full bg-[#14110D]/85 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F1EA]">
              Зад кадър
            </figcaption>
          </motion.figure>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <h3 className="font-serif text-3xl tracking-tight text-[#14110D] sm:text-4xl">
            Alex Cholakov
          </h3>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#C8402A]">
            Кинематограф · Видео продуцент
          </p>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#524E48] sm:text-lg">
            Разказвам истории чрез кадър — документални филми, реклами и съдържание за социални мрежи. Обичам да улавям енергията и красотата на реалния живот и да превръщам идеи във въздействащо видео.
          </p>

          <ul className="mt-8 space-y-3">
            {FACTS.map((f) => (
              <li key={f} className="flex items-baseline gap-3 border-t border-[#14110D]/10 pt-3 text-sm text-[#14110D]">
                <span className="font-mono text-xs text-[#C8402A]">—</span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </ScrollReveal>
      </div>
    </div>
  </section>
);
